export default __webpack_public_path__ + "static/media/Truestrike Armbands.01cf5a4b.jpg";